import { MenuItem } from './menu.item.model';

export interface SuperAdminMenuSection {
  title: string;
  items: MenuItem[];
}

export const sections: SuperAdminMenuSection[] = [
  {
    title: 'nav-item.operational.home',
    items: [
      { icon: 'home', name: 'nav.home', route: '/home' },
    ],
  },
  {
    title: 'nav-item.sales.title',
    items: [
      { icon: 'list', name: 'nav.contractors', route: '/contractors' },
      { icon: 'cloud-upload-outline', name: 'nav.importProspects', route: '/import/prospects' },
      { icon: 'briefcase', name: 'nav.sales', route: '/partner/sales' },
    ],
  },
  {
    title: 'dataHealth.maintenance',
    items: [
      { icon: 'construct', name: 'dataHealth.title', route: '/maintenance/data-health' },
      { icon: 'people', name: 'nav.users', route: '/users' },
      { icon: 'color-wand-outline', name: 'contractor.aiUsage', route: '/super-admin/ai-usage' },
      { icon: 'book-outline', name: 'nav.litteras', route: '/littera/manage' },
      { icon: 'cog-outline', name: 'nav.templates', route: '/super-admin/templates' },
      { icon: 'information-outline', name: 'nav.info', route: '/info' },
    ],
  },
  {
    title: 'nav-item.support.title',
    items: [
      { icon: 'help-circle-outline', name: 'nav-item.support.help', route: '/support' },
    ],
  },
];

export const items: MenuItem[] = sections.flatMap((section) => section.items);

export const superAdminMenu = {
  sections,
  items,
};
